// extracted by mini-css-extract-plugin
export var cardContainer = "_oi-0";
export var cardHeader = "_oi-2";
export var collapsedState = "_oi-3";
export var dragHandle = "_oi-5";
export var dragHandleIcon = "_oi-6";
export var dragging = "_oi-1";
export var titleArea = "_oi-4";